import { render, staticRenderFns } from "./SecaoTabela.vue?vue&type=template&id=60585bbd&scoped=true&"
import script from "./SecaoTabela.vue?vue&type=script&lang=ts&"
export * from "./SecaoTabela.vue?vue&type=script&lang=ts&"
import style0 from "./SecaoTabela.vue?vue&type=style&index=0&id=60585bbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60585bbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDataTable,VIcon})
